// TODO: this can be shared with frontend
type FormatDollarOptions = {
  hideZeroCents?: boolean;
  zeroValue?: string;
};

const defaultOptions: FormatDollarOptions = {
  hideZeroCents: true,
  zeroValue: '0',
};

export function formatDollars(amountInDollars: number | undefined, options?: FormatDollarOptions) {
  const optionsToUse = { ...defaultOptions, ...options };
  const formatted =
    amountInDollars === undefined
      ? optionsToUse.zeroValue
      : `${new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
        }).format(amountInDollars)} `;
  return optionsToUse.hideZeroCents ? formatted?.replace('.00', '') : formatted;
}

export type QueryString = { name: string; value?: string | number | null };
export const getQueryString = (query?: QueryString[]) => {
  let queryString = '?';
  query?.forEach((q) => {
    if (q.value) {
      queryString += `${q.name}=${q.value}&`;
    }
  });

  return queryString.slice(0, -1);
};

// Partners whose Brighte-site URL diverges from the default `${partner}.${domain}`
// pattern. Anything not listed here uses the default partner-prefixed URL.
const PARTNER_URL_OVERRIDES: Record<string, (env: string, domain: string) => string> = {
  'rewiring-au': (env, domain) => `https://${env}${domain}/electrify-2515`,
  brighte: (env, domain) => `https://${env}${domain}/marketplace`,
};

export const getBrighteSitePartnerUrl = (partner?: string) => {
  const domain = import.meta.env.VITE_BRIGHTE_SITE_DOMAIN;
  const stage = import.meta.env.VITE_STAGE;
  const env = stage === 'prod' ? '' : `${stage}.`;

  const override = partner ? PARTNER_URL_OVERRIDES[partner] : undefined;
  if (override) {
    return override(env, domain);
  }

  const partnerName = partner ? `${partner}.` : '';
  return `https://${env}${partnerName}${domain}`;
};

export const formatAddress = (address: { postcode: string; suburb?: string }) => {
  const { postcode, suburb } = address;
  let formattedAddress = '';
  if (suburb && suburb.trim() !== '') {
    formattedAddress += `${suburb}, `;
  }
  if (postcode && postcode.trim() !== '') {
    formattedAddress += postcode;
  }

  return formattedAddress.replace(/^,\s*/, '');
};

export const formatPhoneNumber = (phoneNumber: string) => {
  // Remove all spaces first
  const cleanNumber = phoneNumber.replace(/\s/g, '');

  // If already in international format, return as is
  if (cleanNumber.startsWith('+61')) {
    return cleanNumber;
  }
  // Handle numbers starting with 0 or just the mobile number (9 digits starting with 1-9)
  return cleanNumber.replace(/^(?:0|(?=[1-9]\d{8}$))([1-9]\d{8})$/, '+61$1');
};

export const formatCensoredEmail = (email: string) => {
  const [username, domain] = email.split('@');
  if (!username || !domain) return email;

  // Don't censor if username has only one character
  if (username.length <= 1) return email;

  // For usernames with more than 4 characters, show first 3 characters
  // For usernames with 2-4 characters, show first 1 character
  const visibleChars = username.length > 4 ? 3 : 1;
  const visiblePart = username.slice(0, visibleChars);
  const hiddenPart = '*'.repeat(Math.max(0, username.length - visibleChars));

  return `${visiblePart}${hiddenPart}@${domain}`;
};
